export const environment = {
  name: 'staging',
  production: false,
  apiBaseUrl: 'https://stg.pmapi.wealthmax.co.uk/api',
  notificationHubBaseUrl: 'https://stg.pmapi.wealthmax.co.uk',
  solutionBuilderBaseUrl: 'https://stg.pmapi.wealthmax.co.uk',
  swaggerUrl: 'https://stg.pmapi.wealthmax.co.uk/swagger',
  twenty7tec: {
    authorizeUrl: 'https://stagingcloud.twenty7tec.com/OAuth/Authorize',
    clientId: 'cCLR7jDRHg',
    redirectUri: 'https://stg.crm.wealthmax.co.uk/',
    scope: 'SourcingView SourcingEdit',
  }
};
